import { getCookie } from "cookies-next";

import {
  COOKIES_GLCC_ACCESS_TOKEN,
  COOKIES_USE_GLCC_NATIVE_TOKEN,
  COOKIES_GLCC_NATIVE_ACCESS_TOKEN,
} from "@/constants/cookies";

/**
 * True while the API calls go out with the Glencoco-signed token an Admin
 * gets by impersonating someone (use-impersonate), the same rule
 * getAuthToken follows. Works whether or not the C-14 roles are switched on.
 */
export const isImpersonatedSession = () =>
  !!getCookie(COOKIES_USE_GLCC_NATIVE_TOKEN);

export const getAuthToken = () => {
  const nativeAccessToken = getCookie(COOKIES_GLCC_NATIVE_ACCESS_TOKEN);
  const accessToken = getCookie(COOKIES_GLCC_ACCESS_TOKEN);

  return isImpersonatedSession()
    ? `${nativeAccessToken}` || ""
    : `${accessToken}` || "";
};
